import * as React from "react";
import "./GenericStarInput.css";
import { HRQuestionId } from "../../messages/ObjectIds";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion } from "../../messages/HR";
import StarRatingComponent from "react-star-rating-component";
import { GenericInputHeader } from "./GenericInputHeader";

interface GenericStarInputProps {
    hrStarQuestion: HRQuestionWithStatus<HRQuestion.StarQuestion>;
    isHidden: boolean;
    onChange: (newVal: number, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

export class GenericStarInput extends React.Component<GenericStarInputProps> {
    constructor(props: GenericStarInputProps) {
        super(props);
    }

    handleStarClick(newVal: number) {
        this.props.onChange(newVal, this.props.hrStarQuestion.question.id);
        this.props.onBlur(this.props.hrStarQuestion.question.id);
    }

    render() {
        const question = this.props.hrStarQuestion.question;
        const status = this.props.hrStarQuestion.status;
        return (
            <div className="control-group GenericStarInput__root" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                <GenericInputHeader status={status} questionText={question.questionText}/>
                <div className={"GenericStarInput__questionContainer"}>
                    <StarRatingComponent
                        name={question.questionText}
                        value={question.answer === null ? 0 : question.answer}
                        starCount={5}
                        onStarClick={(val: number) => this.handleStarClick(val)}
                    />
                    <div className={"GenericStarInput__labelContainer"}>
                        <span className={"GenericStarInput__NoStarsLabel"}>No experience</span>
                        <span className={"GenericStarInput__AllStarsLabel"}>Very experienced</span>
                    </div>
                </div>
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericStarInput.tsx